"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggerFactory = exports.enableDebugMode = void 0;
var debugMode = false;
function enableDebugMode() {
    debugMode = true;
}
exports.enableDebugMode = enableDebugMode;
var createLoggerFactory = function (factory) { return ({
    create: function (name) {
        return {
            info: function (message) {
                var optionalParams = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    optionalParams[_i - 1] = arguments[_i];
                }
                if (!debugMode)
                    return;
                console.log.apply(console, __spreadArray(["INFO: [".concat(factory, "][").concat(name, "]: ").concat(message)], optionalParams, false));
            },
            error: function (message) {
                var optionalParams = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    optionalParams[_i - 1] = arguments[_i];
                }
                if (!debugMode)
                    return;
                console.error.apply(console, __spreadArray(["ERROR: [".concat(factory, "][").concat(name, "]: ").concat(message)], optionalParams, false));
            },
            warn: function (message) {
                var optionalParams = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    optionalParams[_i - 1] = arguments[_i];
                }
                if (!debugMode)
                    return;
                console.warn.apply(console, __spreadArray(["WARN: [".concat(factory, "][").concat(name, "]: ").concat(message)], optionalParams, false));
            },
            debug: function (message) {
                var optionalParams = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    optionalParams[_i - 1] = arguments[_i];
                }
                if (!debugMode)
                    return;
                console.debug.apply(console, __spreadArray(["DEBUG: [".concat(factory, "][").concat(name, "]: ").concat(message)], optionalParams, false));
            }
        };
    }
}); };
exports.LoggerFactory = createLoggerFactory('sli-nextjs-metrics');
